import React, { PropTypes } from 'react';
// Components
import MediaPartnerDetailsContainer from '../../../containers/MediaPartnerDetailsContainer';
import MediaPartnersContainer from '../../../containers/MediaPartnersContainer';


const propTypes = {
  params: PropTypes.object,
};

const MediaPartners = ({ params: { id } }) => {
  return (
    <div>
      <MediaPartnersContainer />
      {
        id &&
          <MediaPartnerDetailsContainer id={id} />
      }
    </div>
  );
};

MediaPartners.propTypes = propTypes;

export default MediaPartners;



/** WEBPACK FOOTER **
 ** ./src/components/screens/mediaPartners/MediaPartners.js
 **/